module.exports = __webpack_public_path__ + "img/1543979469.d165914c.jpg";